'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});
exports.getSpecificCardSpec = getSpecificCardSpec;
/**
 * Card Utilities
 * For use with linking a card
 *
 * - get card type [visa, mastercard, amex, discover, maestro, unionpay] based on the card number
 */

var defaultCardSpec = exports.defaultCardSpec = {
	type: 'card',
	fields: {
		ccNumber: {
			required: true,
			pattern: '4[0-9]{12}(?:[0-9]{3})?',
			maxlength: 19
		},
		expirationDate: {
			required: true,
			pattern: '(0[1-9]|1[012])[\/]((20)[0-9]{2}|[0-9]{2})',
			maxlength: 7
		},
		csc: {
			required: true,
			pattern: '[0-9]*',
			maxlength: 3,
			minlength: 3
		}
	}
};

/**
 * Get the card type based on the card number
 * @param {Object} cardSpecs - the card specifications based on user's locale
 * @param {String} cardNumber - the valid card number (numbers only)
 * @return {Object} cardType - the card type specs for a specific card
 */
function getSpecificCardSpec(_ref, cardNumber) {
	var cardTypes = _ref.cardTypes;

	cardNumber = cardNumber.replace(/\D+/g, '');

	for (var card in cardTypes) {
		var cardSpec = cardTypes[card];
		if (new RegExp('^' + cardSpec.fields.ccNumber.autodetect + '$').test(cardNumber)) {
			return cardSpec;
		}
	}
	return defaultCardSpec;
}


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/react-card-number/dist/card-utils.js
// module id = 1142
// module chunks = 5